import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { api } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email: email.trim().toLowerCase(), password });
      localStorage.setItem("rdv_token", r.data.token);
      localStorage.setItem("rdv_admin_email", r.data.email);
      nav("/admin");
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        setError("Email ou mot de passe incorrect. Vérifie tes identifiants et réessaie.");
      } else if (status === 422) {
        setError("Format d'email invalide.");
      } else if (!err.response) {
        setError("Impossible de contacter le serveur. Vérifie ta connexion.");
      } else {
        setError("Une erreur est survenue. Réessaie dans un instant.");
      }
    } finally { setLoading(false); }
  }

  return (
    <div data-testid="admin-login" className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6">
      <form onSubmit={submit} className="max-w-md w-full bg-[#F5F0E6] p-10 border border-[#E8DCC8]">
        <p className="font-hand text-2xl text-[#A3876A] mb-2">Back-office</p>
        <h1 className="font-serif text-4xl mb-8">Connexion</h1>

        {error && (
          <div
            data-testid="admin-login-error"
            role="alert"
            className="flex items-start gap-3 bg-[#FBEBE8] border border-[#E4B8AF] text-[#8A3A2B] px-4 py-3 mb-6 text-sm leading-relaxed"
          >
            <AlertCircle size={18} className="flex-shrink-0 mt-0.5" />
            <span>{error}</span>
          </div>
        )}

        <div className="space-y-6">
          <input
            data-testid="admin-email"
            className="field-input"
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={e => { setEmail(e.target.value); if (error) setError(""); }}
            autoComplete="email"
          />
          <input
            data-testid="admin-password"
            className="field-input"
            type="password"
            placeholder="Mot de passe"
            required
            value={password}
            onChange={e => { setPassword(e.target.value); if (error) setError(""); }}
            autoComplete="current-password"
          />
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading ? "…" : "Se connecter"}
          </button>
        </div>

        <div className="mt-6 text-center">
          <Link
            data-testid="admin-forgot-link"
            to="/admin/forgot-password"
            className="text-sm text-[#A3876A] hover:text-[#8A7158] underline underline-offset-4"
          >
            Mot de passe oublié ?
          </Link>
        </div>
      </form>
    </div>
  );
}
